module.exports = __webpack_public_path__ + "img/atoms-raw-crop.c8badb8c.png";